import * as yup from 'yup';

export const validationSchema = yup.object({
	sellingTypeOfProducts: yup.string().required('Selling Type of Products is required'),
	isSellingToEU: yup.boolean().required('Is Selling to EU is required'),
	sellingPlace: yup.string().required('Selling Place is required'),
	firstName: yup.string().required('First Name is required'),
	lastName: yup.string().required('Last Name is required'),
	phoneNumber: yup.string().required('Phone Number is required'),
	email: yup.string().email('Invalid email').required('Email is required'),
	company: yup.string().required('Company is required'),
	address1: yup.string().required('Address 1 is required'),
	address2: yup.string(),
	cityTown: yup.string().required('City/Town is required'),
	stateRegionProvince: yup.string().required('State/Region/Province is required'),
	zipCode: yup.string().required('Zip Code is required'),
	country: yup.string().max(2).required('Country is required'),
	businessRegistrationNumber: yup.string().required('Business Registration Number is required'),
	storeAddress: yup.string().required('Store Address is required'),
	subscriptionPlan: yup.string().required('Subscription Plan is required'),
	numberOfProductTypes: yup.number().required('Additional Products Types is required'),
	periodStart: yup.string().required('Period Start is required'),
	periodEnd: yup.string().required('Period End is required'),
});
